<div class="flex gap-4 items-center text-xs text-neutral-500 font-bold">
  <h1 class="flex items-center gap-1">
    <i class="ph ph-layout text-base font-normal"></i>
    UI Flow:
    <span class="text-black">{{ name() }}</span>
  </h1>
  <h1 class="relative flex flex-row gap-2">
    UI Flow session ID:
    <div class="flex items-center">
      <div class="truncate w-14 text-black">
        {{ uuid() }}
      </div>
      <flx-icon
        [name]="!copiedTextToClipboard() ? 'copy' : 'circle-check'"
        [class.text-green-300]="copiedTextToClipboard()"
        [cdkCopyToClipboard]="uuid()"
        (cdkCopyToClipboardCopied)="onCopyToClipboardSuccess()"
        class="cursor-pointer"
      ></flx-icon>
    </div>
  </h1>
  <p-tag
    [value]="state()"
    [severity]="severity()"
    class="flx-tag flex"
  />
</div>
